// extracted by mini-css-extract-plugin
var _1 = "AWvBg";
var _2 = "aiwQv";
var _3 = "ehPVq";
var _4 = "JgSJ8";
var _5 = "w8VV9";
export { _1 as "base", _2 as "browseAllValuesButton", _3 as "collapseButton", _4 as "header", _5 as "heading" }
